var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Dollar-blue"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dollar-blue",
    clipPath: "url(#clip-Dollar-blue)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    transform: "translate(8697.221 4279.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M-1.7-12.383a1.187,1.187,0,0,0-.293-.832,2.688,2.688,0,0,0-1-.6A6.167,6.167,0,0,1-5.072-14.95a2.294,2.294,0,0,1-.674-1.767,2.35,2.35,0,0,1,.677-1.736,2.915,2.915,0,0,1,1.824-.8v-1.355h1v1.374a2.681,2.681,0,0,1,1.736.923,2.931,2.931,0,0,1,.621,1.975L.094-16.3H-1.7A1.854,1.854,0,0,0-2-17.449a.993.993,0,0,0-.832-.4,1.009,1.009,0,0,0-.81.312,1.228,1.228,0,0,0-.268.829,1.133,1.133,0,0,0,.28.8,2.856,2.856,0,0,0,1.03.6A6.67,6.67,0,0,1-.536-14.141,2.26,2.26,0,0,1,.139-12.4a2.327,2.327,0,0,1-.677,1.748,2.977,2.977,0,0,1-1.83.778v1.248h-1V-9.862A3.252,3.252,0,0,1-5.318-10.7a2.661,2.661,0,0,1-.744-2.1l.013-.032h1.789a1.6,1.6,0,0,0,.391,1.21,1.383,1.383,0,0,0,.983.365,1.19,1.19,0,0,0,.879-.306A1.111,1.111,0,0,0-1.7-12.383Z",
    transform: "translate(-8686.157 -4257.016)",
    fill: "#289cff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarBlue);
export default __webpack_public_path__ + "static/media/dollar-blue.d7cff4f4df775ec34eaf311dbe1f61f0.svg";
export { ForwardRef as ReactComponent };